// src/components/Header.js

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Tabs,
  Tab,
  IconButton,
  MenuItem,
  Menu,
  LinearProgress
} from '@material-ui/core';
import SettingIcon from '@material-ui/icons/Settings';

import Page from '../Page';
import { useAuth0 } from '../../react-auth0-spa';
import ChangePasswordDialog from '../../containers/ChangePasswordDialog';
import MessageDisplay from '../../containers/MessageDisplay';

const useStyles = makeStyles((theme) => ({
  navbarContainer: {
    display: 'flex'
  },
  root: {
    flexGrow: 1
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  leftControls: {
    flexGrow: 1,
    display: 'flex'
  },
  title: {
    marginTop: 5,
    marginRight: 40
  },
  navigationLinks: {
    marginTop: 8,
    marginLeft: 40
  },
  homeButton: {
    textDecoration: 'none',
    fontSize: '14px',
    letterSpacing: '0.02857em',
    color: 'rgba(255,255,255,0.87)',
    textTransform: 'uppercase'
  },
  rightControls: {
    display: 'flex'
  },
  userName: {
    marginTop: 12,
    marginRight: 30,
    fontSize: 16
  },
  loginLogoutButtons: {},
  appbar: {
    background:
      'linear-gradient(90deg, rgba(44,107,178,1) 0%, rgba(20,29,120,1) 100%) !important'
  },
  settingsIcon: {
    color: theme.palette.tertiary.main
  },
  toolbar: {
    paddingLeft: 0,
    paddingRight: 0
  },
  hastrakLogo: {
    width: 33,
    height: 38,
    display: 'inline-block',
    marginRight: 20
  }
}));

const Header = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const {
    isAuthenticated,
    loginWithRedirect,
    logout,
    loading,
    user
  } = useAuth0();

  const {
    visibleTab,
    onChangePassword,
    setLoggedInUser,
    showProgressBar
  } = props;
  const classes = useStyles();

  React.useEffect(() => {
    setLoggedInUser(user);
  }, [setLoggedInUser, user]);

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleChange = (event, newValue) => {
    props.onChangeTabValueInHeader(newValue);
  };

  const handleChangePasswordClick = () => {
    setAnchorEl(null);
    onChangePassword();
  };

  if (loading || !user) {
    return <div>Login</div>;
  }
  return (
    <React.Fragment>
      <ChangePasswordDialog />
      <MessageDisplay />

      <div className={classes.navbarContainer}>
        <AppBar position="fixed" className={classes.appbar}>
          <Page>
            <Toolbar className={classes.toolbar}>
              <div className={classes.leftControls}>
                <img
                  src="https://hastrak.co.nz/wp-content/uploads/2019/10/HasTrak-logo.png"
                  alt="HasTrak logo"
                  className={classes.hastrakLogo}
                />
                <Typography variant="h6" className={classes.title}>
                  HasTrak
                </Typography>

                {isAuthenticated && (
                  <div className={classes.tabsContainer}>
                    <Tabs
                      value={visibleTab}
                      onChange={handleChange}
                      className={classes.tabsRoot}
                      aria-label="simple tabs example"
                      TabIndicatorProps={{
                        style: { backgroundColor: 'white' }
                      }}
                    >
                      <Tab
                        label="Companies"
                        id="companiesTab"
                        className={classes.tabButton}
                        value={0}
                      />
                      <Tab
                        label="Branches"
                        id="branchesTab"
                        className={classes.tabButton}
                        value={1}
                      />
                      <Tab
                        label="Users"
                        id="userTab"
                        className={classes.tabButton}
                        value={2}
                      />
                      <Tab
                        label="Overview"
                        id="overviewTab"
                        className={classes.tabButton}
                        value={3}
                      />
                    </Tabs>
                  </div>
                )}
              </div>

              <div className={classes.rightControls}>
                <div className={classes.userName}>{user.name}</div>

                <div className={classes.loginLogoutButtons}>
                  {!isAuthenticated && (
                    <Button
                      color="inherit"
                      onClick={() => loginWithRedirect({})}
                    >
                      Log in
                    </Button>
                  )}

                  <React.Fragment>
                    <IconButton
                      aria-label="show 4 new mails"
                      color="inherit"
                      onClick={handleMenu}
                      id="settings-button"
                    >
                      <SettingIcon
                        color="primary"
                        className={classes.settingsIcon}
                      />
                    </IconButton>
                    {isAuthenticated ? (
                      <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                          vertical: 'top',
                          horizontal: 'right'
                        }}
                        keepMounted
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'right'
                        }}
                        open={open}
                        onClose={handleMenuClose}
                      >
                        <MenuItem
                          onClick={handleChangePasswordClick}
                          id="logout-menu-item"
                        >
                          Change Password
                        </MenuItem>
                        <MenuItem
                          onClick={() => logout()}
                          id="logout-menu-item"
                        >
                          Logout
                        </MenuItem>
                      </Menu>
                    ) : null}
                  </React.Fragment>
                </div>
              </div>
            </Toolbar>
          </Page>
          {showProgressBar && <LinearProgress />}
        </AppBar>
      </div>
    </React.Fragment>
  );
};

export default Header;
